import { AppShell, type AppTab } from "@ec2/ui";
import { useT } from "@ec2/i18n/react";
import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

const TAB_PATH: Record<AppTab, string> = {
  quests: "/quests",
  ranks: "/ranks",
  shop: "/shop",
  profile: "/profile",
};

/** AppShell wired to the router: fixed bottom nav + raised Scan on every routed screen. */
export function Shell({ active, children }: { active: AppTab; children: ReactNode }) {
  const t = useT();
  const navigate = useNavigate();
  return (
    <AppShell
      active={active}
      labels={{
        quests: t("ec2.nav.quests"),
        ranks: t("ec2.nav.ranks"),
        scan: t("ec2.nav.scan"),
        shop: t("ec2.nav.shop"),
        profile: t("ec2.nav.profile"),
      }}
      onNavigate={(tab) => void navigate({ to: TAB_PATH[tab] })}
      onScan={() => void navigate({ to: "/scan" })}
    >
      {children}
    </AppShell>
  );
}
